import React from 'react';
import Label from "../../Label";
import {FormControlLabel, FormHelperText, Grid, Radio, RadioGroup, TextField} from "@mui/material";
import {Controller} from "react-hook-form";
import radio from "assets/icon/radio.svg"
import radioChecked from "assets/icon/radio_checked.svg"
import TextOtherField from "../TextOtherField";
import ErrorMessage from "../ErrorMessage";

const InputContent = ({listAnswer,control,type, field,name}) => {
    const handleChange = (event) => {
        field.onChange([{answerId: event.target.value}])
    }
    const value = field.value || []
    return (
        <RadioGroup value={value[0]?.answerId}
                    onChange={handleChange}>
            {listAnswer.map(answer =>
                (
                    <>
                        <FormControlLabel ref={field.ref} key={answer.answerId} value={`${answer.answerId}`}
                                          control={<Radio icon={type!=="d"?<img style={{width: 20}} src={radio} alt=""/>:undefined}
                                                          checkedIcon={type!=="d"?<img style={{width: 20}} src={radioChecked}
                                                                            alt=""/>:undefined}/>}
                                          label={answer.title}/>
                        {value[0]?.answerId ===answer.answerId && answer.hasText &&
                            <TextOtherField control={control} name={`${name}.0.text`} />}
                    </>
                ))}
        </RadioGroup>
    )
}
const RadioField = ({
                        control,
                        name,
                        label,
                        listAnswer,
                        require,
    type
                    }) => {
    return (
        <Grid item xs={12}>
            <Label require={require}>{label}</Label>
            <Controller
                control={control}
                name={name}
                render={({field, fieldState: {error}}) => {
                    return (
                       <>
                           <FormHelperText error>
                               <ErrorMessage message={error?.message}/>
                           </FormHelperText>
                           <InputContent field={field} type={type} name={name} control={control} listAnswer={listAnswer}/>
                       </>
                    );
                }}
            />
        </Grid>
    )
}

export default RadioField